<!--分组商品链接（原引流、礼包商品列表）-->
<template>
  <div class="newPer search giftBagProduct" v-wechat-title="headtitle">
    <div
      class="share_right_btn radius-50 pos-f pl4 pr4 pt4 pb4 r0 zi-1 mr20"
      v-if="arg != '' && arg.indexOf('xcx') < 0"
      @click="shareHandle"
    >
      <img class="d-b w-100" src="/static/images/share_white.png" alt="" />
    </div>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
    >
      <img :src="bannerImg" width="100%" />
      <div class="community" v-if="isApplySearch == 1">
        <header class="searchBox flex-ac pl0 mb0 mt10 over-h">
          <van-search
            class="search flex-1 flex-ac"
            v-model="searchValue"
            placeholder=""
            clearable
            @search="onSearch"
            @clear="onSearch"
          ></van-search>
          <div class="searchBtn f14" @click="onSearch">
            <van-icon name="search" color="#ffffff" size="0.2rem" />
            搜索
          </div>
        </header>
      </div>
      <div class="pro_list">
        <product-item
          v-for="(item, index) of itemList"
          :key="index"
          :prolistItem="item"
          :type="'notScrollTo'"
          :skuSwitch="item.skuSwitch != 0 ? '1' : '0'"
          :markPointData="{ scenepoint: 'GIFTBAG' }"
          :query="{
            actgroupid: $route.query.id
          }"
          :params="{
            isShowCart: info.isShowCart,
            payMethods: info.payMethods
          }"
        ></product-item>
        <div
          class="ad-list"
          v-if="list.length == total && total > 0 && correlationAdlist.length > 0"
        >
          <div
            class="img-wrap w-100"
            :class="index !== correlationAdlist.length - 1 ? 'mb10' : ''"
            v-for="(item, index) of correlationAdlist"
            :key="index"
            @click="goLink(item)"
          >
            <img class="w-100 br4" :src="item.imgUrl" alt="" srcset="" />
          </div>
        </div>
      </div>
    </Scroller>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img
        v-if="info.isShowCart == 1"
        @click="cartListHandle"
        src="/static/images/cart_btn.png"
        alt=""
      />
    </div>
    <van-overlay :show="is_pop" v-if="is_pop && popup_ads && popup_ads.img_path" z-index="99999">
      <div class="wrapper" @click="closeAct">
        <div class="block icon_close_right" @click.stop>
          <van-icon name="close" @click="closeAct" />
          <div style="position: relative">
            <img :src="popup_ads.img_path" @click="goAct('giftgagproductpopup')" />
            <div
              :path="
                popup_ads.ad_target +
                (popup_ads.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=20'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (popup_ads.ad_type == 7 || popup_ads.ad_type == 8)"
            ></div>
          </div>
        </div>
      </div>
    </van-overlay>
    <div class="pos-a l0 r0 t0" v-if="bgimg35">
      <img
        class="w-100"
        :src="bgimg35"
        @touchstart="gotouchstart($event)"
        @touchmove="gotouchmove"
        @touchend="gotouchend"
        alt=""
      />
    </div>
    <!-- 购物车 -->
    <van-action-sheet
      class="action-sheet_scoped"
      v-model="selectedGoodsCartShow"
      title="购物车"
      @click-overlay="selectedGoodsCartShow = false"
    >
      <div class="content flex fd-c" @click.stop>
        <div
          class="pos-a r0 t0 f14 pr20"
          :class="[cartDel == 1 ? 'color-FC0324' : 'color-3']"
          style="line-height: 0.48rem"
          @click="delSwitch"
        >
          {{ cartDel == 1 ? '取消' : '删除' }}
        </div>
        <div class="flex jc-sa pb15" v-if="info.cartPayTypeNum == 2 && arg == ''">
          <div
            class="f15"
            :class="[navId == item.id ? 'color-FC0324 fw-b' : 'color-3']"
            v-for="item of cartNavList"
            @click="cartNavHandle(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
        <div
          class="pl11 pr10 flex-1 scroll-y"
          @scroll="handleCartScroll"
          ref="cartList"
          style="max-height: 60vh; min-height: 60vh"
        >
          <van-checkbox-group
            checked-color="#FC0324"
            v-model="selectedGoodsresult"
            @change="checkedHandle"
            v-if="list.length > 0 && !empty"
          >
            <div class="flex mb12" v-for="(item, index) of list" :key="item.skuid">
              <div class="flex" style="height: 0.8rem">
                <van-checkbox
                  :disabled="
                    cartDel == 1 &&
                    (item.inventory == 0 ||
                      item.islimit != 0 ||
                      item.is_can_buy == 0 ||
                      parseInt(item.canbuycnt) <= 0 ||
                      item.issale == 0)
                  "
                  :name="item.skuid"
                ></van-checkbox>
                <div class="scoped_size80 pos-r mr7 ml7">
                  <img class="scoped_size80 flex-s" v-lazy="item.img_path" alt="" />
                  <img
                    v-if="item.inventory == 0 && item.issale == 0 && item.is_can_buy != 0"
                    class="pos-a l0 t0 r0 b0 m-auto w-87"
                    src="/static/images/soldout.png"
                  />
                  <img
                    v-if="
                      item.inventory == 0 &&
                      item.islimit == 2 &&
                      item.canbuycnt > 0 &&
                      item.is_can_buy != 0
                    "
                    class="pos-a l0 t0 r0 b0 m-auto w-87"
                    src="/static/images/shouqing.png"
                  />
                </div>
              </div>
              <div class="flex-1">
                <div class="f13 color-29 scoped_maxH-36 over-ell-2">{{ item.name }}</div>
                <div class="f12 color-6C mt5 over-h flex ai-c">
                  <div
                    @click="openSku(item, index)"
                    v-if="item.inventory == 1 && (item.islimit == 2 || item.issale == 0)"
                    class="bg-t pt1 pb1 pl7 pr7 radius-10px flex ai-c jc-c scoped_color-fe5e00 again"
                  >
                    重选
                    <van-icon name="arrow-down" color="#FE5E00" />
                  </div>
                  <div
                    v-else
                    class="bg-F6 pt1 pb1 pl7 pr7 radius-10px flex ai-c jc-c"
                    @click="openSku(item, index)"
                  >
                    {{ item.spec }}
                    <van-icon name="arrow-down" />
                  </div>
                </div>
                <div
                  v-if="
                    parseInt(item.canbuycnt) <= parseInt(item.lib_warning) &&
                    parseInt(item.canbuycnt) > 0 &&
                    item.islimit == 0 &&
                    item.issale == 1
                  "
                  class="f11 fw-400 lh17 pt5 pb5 scoped_color-fe5e00"
                >
                  <p>库存紧张</p>
                </div>
                <div class="flex jc-sb ai-c mt2">
                  <div class="flex ai-fe mt6 color-FC0324 f12">
                    ¥
                    <span class="f14 fw-b scoped_lh18">{{ item.sales_price.split('.')[0] }}</span>
                    .{{ item.sales_price.split('.')[1] }}
                  </div>
                  <van-stepper
                    :long-press="false"
                    integer
                    class="goods_stepper ws-n"
                    v-model="item.num"
                    @blur="num(item)"
                    @change="stepperFn(item)"
                    @minus="num(item)"
                    @plus="num(item)"
                    @overlimit="overlimit(item)"
                    :min="1"
                    :max="parseInt(item.canbuycnt)"
                  />
                </div>
              </div>
            </div>
          </van-checkbox-group>
          <div v-else-if="empty">
            <img class="scoped_size80 m-auto mt20" src="/static/images/nocartd.png" alt="" />
            <div class="ta-c f12 color-6 mt10">购物车快饿瘪了T.T</div>
          </div>
        </div>
        <div class="h footer footerIOS opacity-0 f0">
          <div class="pl20 pr20 pt7 pb7">
            <van-button class="f16" round type="info" size="small">&nbsp;占位</van-button>
          </div>
        </div>
        <div class="footer footerIOS bg-F pos-f l0 r0 b0">
          <div class="flex jc-sb ai-c pl11 pr10 pt7 pb7">
            <van-checkbox
              class="f13"
              v-model="checkedAll"
              checked-color="#FC0324"
              @click="checkedAllHandle"
            >
              全选
            </van-checkbox>
            <div class="ml10 flex-1" v-if="cartDel != 1">
              <div class="f0">
                <span class="color-29 f13 flex">
                  合计：¥
                  <span class="f17 fw-b scoped_lh17 ai-fe">{{ totalmoney.split('.')[0] }}</span>
                  .{{ totalmoney.split('.')[1] }}
                </span>
              </div>
            </div>
            <van-button
              class="f16 pl20 pr20"
              round
              type="info"
              size="small"
              :color="true ? 'linear-gradient( 90deg, #FC0324 0%, #FF144F 100%)' : '#C5C5C5'"
              @click="goNext"
              style="min-width: 0.98rem"
              :disabled="!selectedGoodsresult.length"
            >
              {{ (cartDel != 1 ? '去结算' : '确认') + '(' + selectedGoodsresult.length + ')' }}
            </van-button>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" @click="openPreview" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
              <span v-if="skucostprice" class="van-sku__costprice-symbol">¥</span>
              <span v-if="skucostprice" class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <sku-preview
      v-if="listItem.sku_rule_list"
      hide-price
      hide-add-cart-button
      hide-buy-button
      ref="skuPreview"
      :sku-list="listItem.sku_rule_list"
      @change="changePreview"
    />
  </div>
</template>

<script>
import {
  kefu,
  fenxiang,
  basepath,
  isApp,
  isWeixin,
  Base64,
  bannerClick,
  goXcxCreateBtnFn,
  popType,
  wxAjaxData,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import productItem from '../common/productItem'
import skufunc from '../../assets/common/js/sku_func'
import skuPreview from '../common/skuPreview.vue'
import { Sku } from 'vant'
import wx from 'weixin-js-sdk'

export default {
  name: 'giftBagProduct',
  data() {
    return {
      headtitle: '',
      itemList: [],
      info: {},
      correlationAdlist: [],
      bannerImg: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      isnewpersontask: 0,
      newpersonjump: '',
      is_pop: false,
      popup_ads: {},
      total: 0,
      searchValue: '',
      isApplySearch: 0,
      arg: isApp(),
      shareInfo: {},
      shareUrl: basepath + 'Wxmall/WeChat/share' + wxAjaxData,
      bgimg35: '',
      timeOutEvent: null,
      selectedGoodsCartShow: false,
      list: [],
      selectedGoodsresult: [],
      checkedAll: false,
      cartNavList: [
        { name: '自提支付', id: 2 },
        { name: '现金支付', id: 1 }
      ],
      navId: 0,
      cartLoading: false,
      cartFinished: false,
      nowPageCart: 1,
      cartDel: 0,
      showsku: false,
      skuname: '',
      i: 0,
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      skuValueToast: null,
      selectedSkuIndex: -1,
      totalmoney: '0.00',
      totalnum: 0,
      skuidArr: [],
      itemNum: [],
      cartPayMethods: 0,
      empty: false
    }
  },
  components: {
    [Sku.name]: Sku,
    Scroller,
    productItem,
    skuPreview
  },
  mounted: function () {
    window.scrollTo(0, 0)
    this.$newuserFn((data) => {
      if (data.code == 200) {
        this.isnewpersontask = data.isnewpersontask
        this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
      }
    })
    this.getPopup()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {})
    } else {
      next((vm) => {})
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // this.loading = true
    next()
  },
  methods: {
    getPopup() {
      if (!this.$route.query.id) return
      const url = this.$ajax.getMemberDayAd_URL + '?id=' + this.$route.query.id
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.popup_ads = res.data.popup_ads || {}
          if (Object.keys(this.popup_ads).length > 0) {
            popType(100, this.popup_ads, 'getMemberDayAdPop', () => {
              this.is_pop = true
              this.goXcxCreateBtnFn()
            }) // 设为100 原意为 需求：不限制次数
          }
        }
      })
    },
    goXcxCreateBtnFn: function () {
      var that = this
      setTimeout(function () {
        goXcxCreateBtnFn(that)
      }, 500)
    },
    goAct: function (flowArea) {
      this.is_pop = false
      this.bannerClick(this.popup_ads, 0, flowArea)
    },
    closeAct: function () {
      this.is_pop = false
    },
    bannerClick: function (items, index, flowArea) {
      bannerClick(items, index, flowArea, this, () => {
        this.dataCollection(items, index, flowArea)
      })
    },
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    identity() {
      return new Promise((resolve) => {
        if (this.$route.query.id == 392) {
          var url = this.$ajax.getUserIdentity_URL
          if (sessionStorage.getItem('ck_utoken')) {
            url += '?ck_utoken=' + sessionStorage.getItem('ck_utoken')
          }
          this.$customRequestAjax(url)
            .then((res) => {
              if (res.data.code == 200) {
                if (res.data.data.isvip == 0) {
                  resolve()
                } else {
                  this.$router.replace('/')
                }
              } else {
                this.$router.replace('/')
              }
            })
            .catch((err) => {
              this.$router.replace('/')
            })
        } else {
          resolve()
        }
      })
    },
    getData: function () {
      if (!this.$route.query.id) return
      this.identity().then(() => {
        var url =
          this.$ajax.getNewGroupActivityItem_URL +
          '?id=' +
          this.$route.query.id +
          '&pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&keywords=' +
          (this.searchValue || '')
        if (sessionStorage.getItem('ck_utoken')) {
          url += '&ck_utoken=' + sessionStorage.getItem('ck_utoken')
        }
        var that = this
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            if (res.data.showpage == 0) {
              that.finished = true
              if (!res.data.bgimg35) {
                that.$app.goIndex()
              }
              that.bgimg35 = res.data.bgimg35 || ''
              return
            }
            if (that.nowPage === 1) {
              that.info = res.data || {}
              if (that.info.cartPayTypeNum == 2) {
                that.navId = 2
              }
              that.checkActStatus()
              that.shareInfo = res.data.shareInfo || {}
              that.share(res.data.shareInfo)
              that.isApplySearch = res.data.isApplySearch || 0
              that.headtitle = that.$route.meta.title = res.data.title
              that.itemList = res.data.itemlist
              that.correlationAdlist = res.data.correlationAdlist
              that.bannerImg = res.data.bannerimg
              that.total = res.data.total
              that.refresh = false
            } else {
              that.itemList = that.itemList.concat(res.data.itemlist)
              that.bannerImg = res.data.bannerimg
            }
            that.loading = false
            if (res.data.itemlist.length < that.pagesize) {
              that.finished = true
            } else {
              that.finished = false
            }
          }
        })
      })
    },
    // 校验终端
    checkTerminal() {
      this.$dialog
        .alert({
          title: '温馨提示',
          message: '当前系统不支持该链接查询，请关注"创客村"公众号查看详情',
          confirmButtonText: '我知道了',
          className: 'percen_button_alert',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(() => {})
    },
    // 增加弹窗提示校验活动是否开始
    checkActStatus() {
      if (this.info.actStatus && this.info.actStatus != 1) {
        const text = this.info.actStatus == 2 ? '活动未开始' : '活动已结束'
        this.$dialog
          .alert({
            message: text,
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去首页',
            closeOnPopstate: false
          })
          .then(() => {
            this.$app.goIndex()
          })
      }
    },
    openPreview() {
      this.$refs.skuPreview.showPreview(this.selectedSkuIndex)
      skufunc.selectedSkuHandle(this.selectedSkuIndex, this)
    },
    changePreview(index) {
      skufunc.selectedSkuHandle(index, this)
    },
    openSku(item, index) {
      skufunc.openSku_cart(item, index, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_cart(skuValue, this)
    },
    onConfirmClicked() {
      skufunc.onConfirmClicked_cart(this, { actgroupid: this.$route.query.id })
    },
    cartListHandle() {
      // 购物车列表接口 this.nowPageCart
      this.$app.argFunc(
        () => {
          this.cartDel = 0
          this.selectedGoodsCartShow = true
          this.cartNavHandle(this.navId)
        },
        () => {
          if (this.info.payMethods == 2) {
            this.checkTerminal()
            return
          } else {
            this.cartDel = 0
            this.selectedGoodsCartShow = true
            this.cartNavHandle(1)
          }
        },
        () => {
          if (this.info.payMethods == 2) {
            this.checkTerminal()
            return
          } else {
            this.cartDel = 0
            this.selectedGoodsCartShow = true
            this.cartNavHandle(1)
          }
        }
      )
    },
    updateProduct(data, fn) {
      var urlSku = this.$ajax.editItemCart_URL,
        paramsData = data
      if (sessionStorage.getItem('ck_utoken')) {
        paramsData.ck_utoken = sessionStorage.getItem('ck_utoken')
      }
      this.$customRequestAjax.post(urlSku, paramsData).then((res) => {
        if (res.data.code == 200) {
          if (typeof fn == 'function') {
            fn()
          }
        }
      })
    },
    totalMoney() {
      // 计算购物车中已选商品的合计金额
      let total = 0,
        nums = 0
      this.skuidArr = []
      this.itemNum = []
      this.list.forEach((item) => {
        if (this.selectedGoodsresult.includes(item.skuid)) {
          // 金额为单价 * 数量，确保为数字类型
          let price = parseFloat(item.sales_price)
          let num = parseInt(item.num)
          if (!isNaN(price) && !isNaN(num)) {
            total += price * num
            nums += num
          }
          this.skuidArr.push(item.skuid)
          this.itemNum.push(item.num)
        }
      })
      // 可根据需要将合计金额赋值到data中某个变量
      this.totalmoney = total.toFixed(2)
      this.totalnum = nums
    },
    delSwitch() {
      this.cartDel = this.cartDel == 1 ? 0 : 1
      this.checkedHandle(this.selectedGoodsresult)
    },
    handleCartScroll(event) {
      const target = event.target
      // 判断是否滚动到底部
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 5) {
        // 执行加载更多数据的逻辑
        this.nowPageCart++
        this.loadMoreCartData()
      }
    },

    loadMoreCartData() {
      // 在这里实现加载更多购物车数据的逻辑
      // 示例代码：
      if (!this.cartLoading && !this.cartFinished) {
        this.cartLoading = true
        var url =
          this.$ajax.getItemCart_URL +
          '?pageno=' +
          this.nowPageCart +
          '&pagesize=10&payMethods=' +
          this.navId
        if (sessionStorage.getItem('ck_utoken')) {
          url += '&ck_utoken=' + sessionStorage.getItem('ck_utoken')
        }
        // 模拟异步加载数据
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            if (this.nowPageCart == 1) {
              this.cartPayMethods = res.data.payMethods
              this.info.cartPayTypeNum = res.data.cartPayTypeNum
              if (this.info.cartPayTypeNum == 2 && this.navId == 0) {
                this.navId = this.cartPayMethods
              }
              this.list = this.cartDataHandle(res.data.cartlist)
            } else {
              this.list = this.list.concat(this.cartDataHandle(res.data.cartlist))
            }
            if (res.data.cartlist.length < 10) {
              this.cartFinished = true
            } else {
              this.cartFinished = false
            }
            if (res.data.cartlist.length == 0) {
              this.selectedGoodsresult = []
              localStorage.removeItem('selectedGoodsresult_' + this.cartPayMethods)
              this.empty = true
            } else {
              if (localStorage.getItem('selectedGoodsresult_' + this.cartPayMethods)) {
                let localResult = JSON.parse(
                  localStorage.getItem('selectedGoodsresult_' + this.cartPayMethods)
                )
                if (Array.isArray(localResult)) {
                  const filtered = localResult.filter((val) =>
                    this.list.some((it) => it.skuid == val)
                  )
                  const unique = Array.from(new Set(filtered))
                  this.selectedGoodsresult = unique
                }
              }
            }
            this.checkedHandle(this.selectedGoodsresult)
          }
          this.cartLoading = false
        })
      }
    },
    cartDataHandle(list) {
      return list.map((item) => {
        item.temp_sales_price = item.sales_price
        var indexWh = 0
        var indexDs = 0
        item.sku_rule_list.map((itemSon) => {
          itemSon.temp_sales_price = itemSon.sales_price
          if (
            itemSon.canbuycnt <= 0 ||
            itemSon.islimit == 2 ||
            itemSon.issale == 0 ||
            item.is_can_buy == 0
          ) {
            indexWh++
          }
          if (itemSon.islimit == 1) {
            indexDs++
          }
        })
        if (
          item.sku_rule_list &&
          item.sku_rule_list.length <= indexWh &&
          item.sku_rule_list.length > indexDs
        ) {
          item.inventory = 0 /**无货状态 */
        } else {
          item.inventory = 1 /**有货状态 */
        }
        if (
          item.islimit != 0 ||
          parseInt(item.canbuycnt) <= 0 ||
          item.issale == 0 ||
          item.is_can_buy == 0
        ) {
          this.selectedGoodsresult = this.selectedGoodsresult.filter((val) => val != item.skuid)
        }
        return item
      })
    },
    checkedHandle(list) {
      const validList = this.list.filter(
        (item) =>
          item.inventory != 0 &&
          item.islimit == 0 &&
          item.is_can_buy != 0 &&
          parseInt(item.canbuycnt) > 0 &&
          item.issale != 0
      )
      const len = this.cartDel == 1 ? validList.length : this.list.length
      if (list.length == len && len > 0) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
      this.selectedGoodsresult = list
      localStorage.setItem(
        'selectedGoodsresult_' + this.cartPayMethods,
        JSON.stringify(this.selectedGoodsresult)
      )
      this.totalMoney()
    },
    checkedAllHandle() {
      if (this.checkedAll) {
        this.selectedGoodsresult = this.list.map((item) => item.skuid)
      } else {
        this.selectedGoodsresult = []
      }
      this.totalMoney()
    },
    cartNavHandle(id) {
      this.navId = id
      // 根据选中的导航项加载不同的购物车数据
      this.nowPageCart = 1
      this.cartLoading = false
      this.cartFinished = false
      this.empty = false
      this.$nextTick(() => {
        this.$refs.cartList.scrollTo(0, 0)
      })
      this.loadMoreCartData()
    },
    stepperFn(items) {
      var that = this
      if (items.num < 0) items.num = Math.abs(items.num)
      setTimeout(function () {
        if (that.cartDel != 1) {
          that.totalMoney()
        }
      })
    },
    num: function (items) {
      var that = this
      setTimeout(function () {
        that.totalMoney()
        var datas = {
          skuids: items.skuid,
          nums: items.num,
          actgroupid: that.$route.query.id
        }
        that.updateProduct(datas)
      })
    },
    overlimit: function (items) {
      if (items.num >= items.canbuycnt) {
        this.$toast('数量超出范围~')
      }
    },
    goNext() {
      if (this.cartDel == 1) {
        this.delHandle()
      } else {
        this.goBuy()
      }
    },
    delHandle() {
      if (this.selectedGoodsresult.length == 0) {
        this.$toast('请选择要删除的商品~')
        return
      }
      var that = this
      this.$dialog
        .confirm({
          title: '确认删除',
          message: '是否将所选商品移出购物车？',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          className: 'collect_button_alert',
          confirmButtonColor: '#FFFCFC',
          cancelButtonColor: '#FC0324',
          closeOnPopstate: true
        })
        .then(() => {
          var datas = {
            skuids: that.skuidArr.join(','),
            nums: that.itemNum.join(','),
            actgroupid: that.$route.query.id
          }
          if (sessionStorage.getItem('ck_utoken')) {
            datas.ck_utoken = sessionStorage.getItem('ck_utoken')
          }
          that.$customRequestAjax.post(that.$ajax.delItemCart_URL, datas).then((res) => {
            if (res.data.code == 200) {
              that.list = that.list.filter((item) => !that.selectedGoodsresult.includes(item.skuid))
              that.selectedGoodsresult = []
              that.checkedHandle(that.selectedGoodsresult)
              if (that.list.length == 0) {
                that.navId = 0
                that.selectedGoodsCartShow = false
              }
              that.$toast('删除成功~')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    goBuy() {
      var that = this
      var shopConfirmResult = {
        skuidArr: this.skuidArr,
        itemNum: this.itemNum,
        from: 1,
        orderfrom: 0,
        totalmoney: this.totalmoney,
        totalnum: this.totalnum,
        liveId: [],
        roomId: [],
        LiveIdArrOversea: [],
        roomIdArrOversea: [],
        course_params: []
      }
      if (this.totalnum > 0) {
        var urlCheck
        if (shopConfirmResult.skuidArr.length > 0) {
          urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            shopConfirmResult.skuidArr.join() +
            '&buynum=' +
            shopConfirmResult.itemNum.join()
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code == 200) {
              if (res.data.vipLevelLimitMsg) {
                that.$dialog
                  .confirm({
                    message: res.data.vipLevelLimitMsg,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去查看'
                  })
                  .then(() => {
                    // on close
                    that.$app.argLink({ path: '/vipcenter' })
                  })
                return
              }
              if (that.$route.query.id) {
                shopConfirmResult.actgroupid = that.$route.query.id
              }
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              /**埋点 */
              that.dataCollection_1()
              that.selectedGoodsCartShow = false
              that.$nextTick(() => {
                that.$app.argFunc(
                  () => {
                    const params = that.cartPayMethods == 2 ? 'yl=1&acttype=hc_welfare_private' : ''
                    that.$router.push('/order?' + params)
                  },
                  () => {
                    if (that.cartPayMethods == 2) {
                      that.checkTerminal()
                    } else {
                      shopConfirmResult.orderHadOnShow = 0
                      shopConfirmResult.isInitData = 1
                      shopConfirmResult.live_id = ''
                      shopConfirmResult.type = 'addToConfirmOrder'
                      wx.miniProgram.navigateTo({
                        url:
                          '/pages/order/main?shopConfirmResult=' +
                          JSON.stringify(shopConfirmResult) +
                          '&scenepoint=' +
                          encodeURIComponent(window.document.title) +
                          '&exclusiveid=' +
                          exclusiveidFn() +
                          pointParams('&')
                      })
                    }
                  },
                  () => {
                    if (that.cartPayMethods == 2) {
                      that.checkTerminal()
                    } else {
                      var obj = {
                        type: 'addToConfirmOrder',
                        skuids: shopConfirmResult.skuidArr.join(),
                        item_num: shopConfirmResult.itemNum.join(),
                        from: shopConfirmResult.from,
                        actgroupid: shopConfirmResult.actgroupid
                      }
                      that.$commonburiedPoint({
                        data: {
                          scenepoint: window.document.title,
                          scenedesc: window.location.href,
                          url: 'order-confirm'
                        },
                        rnType: 'addToConfirmOrder',
                        callback: () => {
                          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                        }
                      })
                    }
                  }
                )
              })
            }
          })
        }
      }
    },
    dataCollection_1() {
      let checkedList = this.list.filter((item) => this.selectedGoodsresult.includes(item.skuid))
      for (let i in checkedList) {
        let params = {
          productId_var: checkedList[i].itemid /**商品id */,
          productName_var: checkedList[i].name /**商品名称 */,
          firstCat_var: '' /**商品一级分类 */,
          productType_var: '' /**商品品类 */,
          productFormat_var: checkedList[i].skuid /**商品规格 */,
          buyQuantity_var: checkedList[i].num /**购买数量 */,
          payAmount_var: (checkedList[i].sales_price * checkedList[i].num).toFixed(2) /**支付金额 */
        }
        gio('track', 'settleProduct', params)
      }
    },
    shareHandle() {
      this.$app.argFunc(null, null, () => {
        let base = new Base64()
        this.$app.shareFriends(
          {
            title: encodeURIComponent(this.shareInfo.title),
            desc: encodeURIComponent(this.shareInfo.desc),
            img: this.shareInfo.img,
            link: encodeURIComponent(
              this.shareUrl +
                '&type=giftproudct&params=' +
                base.encode(JSON.stringify({ id: this.$route.query.id }))
            )
          },
          'app'
        )
      })
    },
    onSearch() {
      this.nowPage = 0
      this.itemList = []
      this.correlationAdlist = []
      this.total = 0
      this.onInfinite()
    },
    // 点击活动跳转
    goLink(item) {
      this.$app.argStaticLink(item.link)
    },
    newpersontask() {
      var arg = isApp()
      window.location =
        this.newpersonjump + (this.newpersonjump.indexOf('?') >= 0 ? arg : '?1=1' + arg)
    },
    share(shareInfo) {
      let base = new Base64()
      let params = {
          title: encodeURIComponent(shareInfo.title),
          desc: encodeURIComponent(shareInfo.desc),
          imgx: shareInfo.img,
          type: 'giftproudct',
          path: 'giftbagproduct',
          dataStr:
            'type=giftproudct&params=' + base.encode(JSON.stringify({ id: this.$route.query.id }))
        },
        arg = isApp()
      if (arg.indexOf('xcx') >= 0) {
        var xcxObj = {
          type: 'giftproudct',
          link: basepath + 'giftbagproduct?id=' + this.$route.query.id + arg,
          title: encodeURIComponent(shareInfo.title),
          img: shareInfo.img
        }
        wx.miniProgram.postMessage({ data: xcxObj })
      } else if (arg == '' && isWeixin()) {
        fenxiang(params)
      }
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.itemList = []
      this.correlationAdlist = []
      this.total = 0
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    gotouchstart: function (event) {
      let that = this
      clearTimeout(that.timeOutEvent) //清除定时器
      that.timeOutEvent = 0
      that.timeOutEvent = setTimeout(function () {
        //执行长按要执行的内容，
        console.log('我长按了')
        that.saveimg()
        event.preventDefault()
      }, 600) //这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend: function () {
      let that = this
      clearTimeout(that.timeOutEvent)
      if (that.timeOutEvent != 0) {
        //这里写要执行的内容（尤如onclick事件）
      }
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove: function () {
      let that = this
      clearTimeout(that.timeOutEvent) //清除定时器
      that.timeOutEvent = 0
    },
    saveimg: function () {
      this.$app.saveimg(this.bgimg35)
    }
  }
}
</script>

<style scoped lang="scss">
.newPer {
  background: #fff;
  min-height: 100%;
  > img {
    width: 100%;
  }

  .pro_list {
    padding: 0.1rem 0.11rem 0;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .pro_item:nth-child(2n) {
      padding-left: 0.035rem;
    }
    .pro_item:nth-child(2n-1) {
      padding-right: 0.035rem;
    }
  }
}
.search /deep/ .van-search__content {
  border: none;
}
.search /deep/ .van-field__left-icon {
  display: none;
}
.scoped_size80 {
  width: 0.8rem;
  height: 0.8rem;
}
.scoped_maxH-36 {
  max-height: 0.36rem;
}
.scoped_lh18 {
  line-height: 0.18rem;
}
.scoped_lh17 {
  line-height: 0.17rem;
}
.again {
  border: 0.01rem solid #fe5e00;
}
.scoped_color-fe5e00 {
  color: #fe5e00;
}
.van-action-sheet__close {
  display: none;
}
</style>
<style lang="scss">
@import './css/giftBagProduct.scss';
</style>



// WEBPACK FOOTER //
// src/components/homepage/giftBagProduct.vue